(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gtm_datalayer"] && !Shopify.designMode) return;
  try {
    const pageTemplate = document.body.dataset.template;

if (pageTemplate === 'content-hub') {
  document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.querySelector(".hb_beauty-guide__wrapper");
    if (!wrapper) return;

    const sectionTitle = wrapper.querySelector(".hb_beauty-guide__title h1")?.innerText.trim() || "Beauty Guide";

    const links = wrapper.querySelectorAll(".hb_beauty-guide__link");

    links.forEach((link) => {
      link.addEventListener("click", function () {
        const linkText = link.textContent.trim();
        const linkPath = link.getAttribute("href") || undefined;
        const linkClass = link.querySelector("img") ? "IMG" : "TXT";

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "content_click",
          click_type: "Beauty Guide",
          section: sectionTitle,
          link_text: linkText,
          link_path: linkPath,
          link_class: linkClass
        });
      });
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const blogContainer = document.querySelector('[js-blog-event]');
    if (!blogContainer) return;

    const sectionTitle = blogContainer.querySelector('h2')?.innerText.trim() || 'Blog Section';

    // Common push function
    const pushEvent = ({ click_type, link_text, link_path, link_class }) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "content_click",
        click_type,
        section: sectionTitle,
        link_text,
        link_path,
        link_class
      });
    };

    // Blog titles (a.full-unstyled-link)
    blogContainer.querySelectorAll('a.full-unstyled-link').forEach(link => {
      link.addEventListener('click', function () {
        pushEvent({
          click_type: "Blog Article Title",
          link_text: link.textContent.trim(),
          link_path: link.getAttribute('href') || undefined,
          link_class: link.querySelector('img') ? "IMG" : "TXT"
        });
      });
    });

    // Read more buttons
    blogContainer.querySelectorAll('a.article-card__read-more--btn').forEach(btn => {
      btn.addEventListener('click', function () {
        pushEvent({
          click_type: "Blog Read More",
          link_text: btn.textContent.trim(),
          link_path: btn.getAttribute('href') || undefined,
          link_class: "TXT"
        });
      });
    });

    // "View all" links (top & bottom)
    blogContainer.querySelectorAll('a[href="/blogs/the-over-40-edit"]').forEach(viewAll => {
      viewAll.addEventListener('click', function () {
        pushEvent({
          click_type: "Blog View All",
          link_text: viewAll.textContent.trim(),
          link_path: viewAll.getAttribute('href') || undefined,
          link_class: "TXT"
        });
      });
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const makeupTipsSection = document.querySelector('#how-to-videos');
    if (!makeupTipsSection) return;

    const sectionTitle = makeupTipsSection.querySelector('h2')?.innerText.trim() || "Makeup Tips";

    // Helper to push content_click event
    const pushEvent = ({ click_type, link_text, link_path, link_class }) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "content_click",
        click_type,
        section: sectionTitle,
        link_text,
        link_path,
        link_class
      });
    };

    // Watch buttons inside slides
    const watchButtons = makeupTipsSection.querySelectorAll('.hb_makeup-tips__slide-button');
    watchButtons.forEach(button => {
      button.addEventListener('click', () => {
        const card = button.closest('.hb_makeup-tips__slide-item');
        const title = card?.querySelector('.hb_makeup-tips__slide-title')?.innerText.trim() || "Untitled";
        pushEvent({
          click_type: "Makeup Tips - Watch Video",
          link_text: title,
          link_path: "#",
          link_class: "TXT"
        });
      });
    });

    // See all videos link
    const seeAllLink = makeupTipsSection.querySelector('.hb_makeup-tips__see-all');
    if (seeAllLink) {
      seeAllLink.addEventListener('click', () => {
        pushEvent({
          click_type: "Makeup Tips - See All",
          link_text: seeAllLink.innerText.trim(),
          link_path: seeAllLink.getAttribute('href') || undefined,
          link_class: "TXT"
        });
      });
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector('#gorgeous-at-any-age');
    if (!section) return;

    const button = section.querySelector('.hb_image-with-text__btn');
    const sectionTitle = section.querySelector('h2')?.innerText?.trim() || "Unknown Section";

    if (button) {
      button.addEventListener("click", function () {
        const linkHref = this.getAttribute("href")?.trim();
        
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "content_click",
          click_type: "button",
          section: sectionTitle,
          link_text: this.innerText.trim(),
          link_path: linkHref || undefined,
          link_class: "TXT"
        });
      });
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    const discoverySection = document.querySelector('.hb_discovery-banner');
    if (!discoverySection) return;

    const buttons = discoverySection.querySelectorAll('a.hb_discovery-banner__button, a.hb_discovery-banner__chat-link');

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        const linkHref = button.getAttribute("href")?.trim();
        const linkText = button.innerText.trim();
        const sectionTitle = discoverySection.querySelector('h2')?.innerText?.trim() || "Discovery Banner";

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "content_click",
          click_type: "button",
          section: sectionTitle,
          link_text: linkText,
          link_path: linkHref || undefined,
          link_class: "TXT"
        });
      });
    });
  });
}

if (pageTemplate === 'quizzes') {
    document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector(".new_featured_blog");
    if (!section) return;

    const buttons = section.querySelectorAll("a, button");

    buttons.forEach((btn) => {
        btn.addEventListener("click", function () {
        const linkText = btn.innerText.trim();
        const linkPath = btn.getAttribute("href")?.trim() || "undefined";
        const isImg = btn.querySelector("img") !== null;
        const linkClass = isImg ? "img" : "txt";

        const heading = section.querySelector("h1, h2, h3, .heading, .title");
        const sectionTitle = heading?.innerText?.trim() || "Unnamed Section";

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "blog_click",
            click_type: "new_featured_blog",
            section: sectionTitle,
            link_text: linkText,
            link_path: linkPath,
            link_class: linkClass,
        });
        });
    });
    });

    document.querySelectorAll('.Blog_template_main_new a').forEach((link) => {
    link.addEventListener('click', function () {
        const linkPath = link.getAttribute('href') || undefined?.trim() || 'undefined';
        const linkText = link.innerText?.trim() || 'undefined';
        const closestSection = link.closest('.Blog_template_main_new');
        const sectionTitle = closestSection?.querySelector('h2')?.innerText?.trim() || 'undefined';
        const isImage = link.querySelector('img') !== null;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        event: 'blog_click',
        click_type: 'blog_template',
        section: sectionTitle,
        link_text: linkText,
        link_path: linkPath,
        link_class: isImage ? 'img' : 'txt'
        });
    });
    });
}

if (pageTemplate === 'faq-new' || pageTemplate === 'faq') {
    const accordionItemsFaq = document.querySelectorAll("[js-accordion-item-faq]");
    if (accordionItemsFaq.length) {
      accordionItemsFaq.forEach(accordionItem => {
        accordionItem.addEventListener("click", function () {
          const _this = this;
          setTimeout(() => {
            const isActive = _this.classList.contains("active");
            const sectionBox = _this.closest(".Page_faq_category_box");
            const sectionTitle = sectionBox
              ? sectionBox.querySelector(".Page_faq_category_box_title h2")?.innerText.trim() || ""
              : "";
    
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "faq_click",
              section: sectionTitle,
              link_path: undefined,
              click_type: isActive ? "accordion" : "accordion",
              link_id: isActive ? "expand" : "collapse",
              link_text: _this.innerText.trim()
            });
          }, 150);
        });
      });
    }
    
    document.addEventListener("DOMContentLoaded", function () {
      const quickActionButtons = document.querySelectorAll(".Page_quick_actions_grid_box_button .secondary_button");
    
      quickActionButtons.forEach((button) => {
        button.addEventListener("click", function () {
          const sectionHeading = document.querySelector(".Page_quick_actions_section_main_heading_text h2");
          const sectionName = sectionHeading ? sectionHeading.textContent.trim() : "Quick Actions";
    
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "faq_click",
            click_type: "Quick Actions",
            section: sectionName,
            link_text: button.textContent.trim(),
            link_path: button.getAttribute("href") || undefined,
            link_id: button.id || undefined
          });
        });
      });
    });
    
    
    document.addEventListener("DOMContentLoaded", function () {
      const faqInternalLinks = document.querySelectorAll(".Page_faq_category_box_single_faq a");
    
      faqInternalLinks.forEach((anchorTag) => {
        anchorTag.addEventListener("click", function () {
          const sectionBox = anchorTag.closest(".Page_faq_category_box");
          const sectionTitle = sectionBox
            ? sectionBox.querySelector(".Page_faq_category_box_title h2")?.innerText.trim() || ""
            : "";
    
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "faq_click",
            click_type: "accordion",
            section: sectionTitle,
            link_text: anchorTag.textContent.trim(),
            link_path: anchorTag.getAttribute("href") || undefined,
            link_id: anchorTag.id || undefined
          });
        });
      });
    });
    
    document.addEventListener("DOMContentLoaded", function () {
      const faqTabs = document.querySelectorAll(".Page_faq_tab");
    
      faqTabs.forEach((tab) => {
        tab.addEventListener("click", function () {
          const sectionName = "FAQ";
    
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "faq_click",
            click_type: "FAQ Tab",
            section: sectionName,
            link_text: tab.textContent.trim(),
            link_path: tab.getAttribute("href"),
            link_id: tab.id || undefined
          });
        });
      });
    });
}
  } catch(e) { console.error(e); }
})();

})();
